import { handleSwal } from "utils/sweetAlert";

function errorResponseHandler(error) {
  if (error) {
    let message;
    if (error.response) {
      // console.log(error.response);
      if (error.response.status === 401) {
        message = "Please Login Again!";
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else if (error.response.status === 500)
        message = "Something went wrong";
      else message = error.response.data.message;

      handleSwal(message, "error");

      return Promise.reject(error);
    }
  }
}

export default errorResponseHandler;
